import { UseFormSetValue, FieldValues } from 'react-hook-form';

export const clearOperationTypeFields = (
    value: string | null,
    setValue: UseFormSetValue<FieldValues>
): void => {
    if (value === 'Transfer') {
        setValue('keyPix', null);
        setValue('pixKeyTypeValue', null);
    } else {
        setValue('type', null);
        setValue('bankCode', null);
        setValue('agency', null);
        setValue('accountDigit', null);
        setValue('account', null);
    }
};
